import { useTranslation } from 'react-i18next';

import { Container, Header } from '~/components';
import { PricingStats } from '~/pages/Settings/Pricing/PricingStats';

import { featuresStyle, infoStyle, pricingContainerStyle, statsStyle } from './Pricing.css';
import { PricingFeatures } from './PricingFeatures';
import { PricingInfo } from './PricingInfo';

export const Pricing = () => {
  const { t } = useTranslation(['pricing']);

  return (
    <>
      <Header.Root sticky={false}>
        <Header.Content title={t('pricing:pageHeader.title')} />
      </Header.Root>

      <Container className={pricingContainerStyle}>
        <div className={infoStyle}>
          <PricingInfo />
        </div>

        <div className={statsStyle}>
          <PricingStats />
        </div>

        <div className={featuresStyle}>
          <PricingFeatures />
        </div>
      </Container>
    </>
  );
};
